import React, { createContext, useCallback, useState } from "react";
import * as uuid from "uuid";

export type NotificationsContextType = {
    notifications: Notification[];
    handleCreateNotification: (payload: Notification) => void;
    handleCloseNotification: (payload: Notification) => void;
    handleDeleteAllNotifications: () => void;
};

type Notification = {
    id: string;
    status: "error" | "success" | "info" | "warning" | null | undefined;
    title: string | undefined;
    body: React.ReactNode;
    expiracy?: Date;
};

export const NotificationsContext = createContext<NotificationsContextType | undefined>(undefined);

interface NotificationsProviderProps {
    children: React.ReactNode;
}

const NotificationProvider: React.FC<NotificationsProviderProps> = ({ children }) => {
    const [notifications, setNotifications] = useState<Notification[]>([]);

    const handleCloseNotification = useCallback(
        (payload: Notification) => {
            setNotifications(notifications.filter((x) => x.id !== payload.id));
        },
        [setNotifications, notifications]
    );

    const handleCreateNotification = useCallback(
        (payload: Notification) => {
            payload.id = uuid.v4();
            setNotifications([payload]);
        },
        [setNotifications]
    );
    const handleDeleteAllNotifications = useCallback(() => {
        setNotifications([]);
    }, [setNotifications]);

    return (
        <NotificationsContext.Provider
            value={{
                notifications,
                handleCreateNotification,
                handleCloseNotification,
                handleDeleteAllNotifications,
            }}
        >
            {children}
        </NotificationsContext.Provider>
    );
};

export default NotificationProvider;
